import { BlockReason, CardType, DebitCardBlockRequest } from '@generated-types';
import { cardTypeDel, cardTypePut } from '@utils/query-utils';

import { getTypeCardBasePath, REST_BASE_URL_DEBIT_CARDS } from '../common';

export interface SoftBlockCardRequest {
    cardType: CardType;
    cardId: string;
}

export interface DeleteCardRequest extends SoftBlockCardRequest {}

export interface HardBlockCardRequest {
    cardId: string;
    blockRequest: DebitCardBlockRequest;
}

export const softBlockCard = async (cardType: CardType, cardId: string) => {
    const request: DebitCardBlockRequest = {
        reason: BlockReason.SOFT_BLOCK,
    };

    return cardTypePut(cardType)(`${getTypeCardBasePath(cardType)}/${cardId}/block`, request);
};

export const hardBlockDebitCard = async (cardId: string, blockRequest: DebitCardBlockRequest) => {
    const { reason, reorder } = blockRequest;

    const request: DebitCardBlockRequest = {
        reason,
        reorder,
    };

    return cardTypePut(CardType.DEBIT)(`${REST_BASE_URL_DEBIT_CARDS}/${cardId}/block`, request);
};

export const deleteCard = async (cardType: CardType, cardId: string) =>
    cardTypeDel(cardType)(`${getTypeCardBasePath(cardType)}/${cardId}`);

export const reopenCard = async (cardType: CardType, cardId: string) =>
    cardTypeDel(cardType)(`${getTypeCardBasePath(cardType)}/${cardId}/block`);
